import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Status } from '../types/status';

/**
 * scope api service
 * @class ScopeService
 * @typedef {ScopeService}
 */
@Injectable({
    providedIn: 'root'
})
export class ScopeService {
    /** ignore in coverage */
    #httpClient = inject(HttpClient);

    /**
     * get overall status of scope services
     * e.g. status: { indicator: 'minor' | 'partial' | 'major' | 'maintenance'; description: string }
     * @returns object with current status
     */
    getStatus(): Observable<Status> {
        const statusApi = 'https://status.riege.com/api/v2/status.json';
        return this.#httpClient.get<Status>(statusApi).pipe((res) => res);
    }
}
